import React from "react"
import { IntlContextConsumer, changeLocale } from "gatsby-plugin-intl"

const languageName = {
  en: "Pounds",
  de: "Euros",
  se:"SEK"
}

const Language = () => {
  return (
    <div>
      <IntlContextConsumer>
        {({ languages, language: currentLocale }) =>
          languages.map(language => (
            <a
              key={language}
              onClick={() => changeLocale(language)}
              style={{
                // color: currentLocale === language ? `black` : `black`,
                margin: 10,
                textDecoration: currentLocale === language ? `underline` : `none`,
                cursor: `pointer`,
              }}
            >
              {languageName[language]}
            </a>
          ))
        }
      </IntlContextConsumer>
    </div>
  )
}

export default Language

// import React,{useState,useContext} from 'react';
// import StoreContext from '~/context/StoreContext'

// const CurrencySwitcher = () => {
//     const { setCurrency } = useContext(StoreContext)

//     // const options = []
//     return (
//         <select onChange={(e) => {setCurrency(e.target.value)}}>
//             <option value={"price_uk"}>
//             Pounds
//             </option>
//             <option value={"price_sek"}>
//             SEK
//             </option>
//             <option value={"price_euro"}>
//             SEK
//             </option>
//       </select>
//     );
// };

// export default CurrencySwitcher;